import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';

/**
 * Swal when the API returns WAITING_LIST_MAX_EXCEEDED (max per user / waiting list cap).
 */
export async function showWaitingListMaxExceededSwal(
  translate: TranslateService,
  maxLimit?: number
): Promise<void> {
  const title = translate.instant('WAITINGLIST.MaxExceededTitle');
  const text = maxLimit != null && maxLimit > 0
    ? translate.instant('WAITINGLIST.MaxExceededByUser', { max: maxLimit })
    : translate.instant('WAITINGLIST.MaxExceededByUserSimple');
  await Swal.fire({
    title,
    text,
    icon: 'warning',
    confirmButtonText: translate.instant('Accept'),
    customClass: { confirmButton: 'swal-confirm-corp' },
  });
}
